import { usePlaylistAssignmentsForPortal, usePlaylistAssignmentsPortals } from './playlistAssignmentsQueries';
import { ASSIGNMENT_IDS_PARAM } from './playlistAssignmentsRouting';
import { useParams } from 'react-router-dom';
import { TABLE_SIZE, useDisplayedData } from '../table';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
export const usePlaylistAssignmentsParams = () => {
  const {
    playlistId,
    portalId
  } = useParams();
  const [assignmentIdsParam] = useSearchParam(ASSIGNMENT_IDS_PARAM);
  const assignmentIds = assignmentIdsParam && assignmentIdsParam.length ? assignmentIdsParam.map(Number) : [];
  return {
    playlistId: Number(playlistId),
    portalId: Number(portalId),
    assignmentIds
  };
};
export const useFilteredPlaylistAssignmentsPortals = ({
  playlistId,
  page = 1,
  search
}) => {
  const [[searchTeams]] = useSearchParam(FILTER_TYPES.SEARCH_TEAMS);
  const [[assignedBy]] = useSearchParam(FILTER_TYPES.ASSIGNED_BY);
  const query = searchTeams || search;
  const {
    playlistAssignmentsPortals,
    total,
    playlistAssignmentsPortalsLoading
  } = usePlaylistAssignmentsPortals({
    playlistId,
    offset: (page - 1) * TABLE_SIZE,
    limit: TABLE_SIZE,
    query,
    assignedByRequestingUser: assignedBy === 'ME'
  });
  const {
    playlistAssignmentsPortals: displayedPortals,
    total: displayedTotal
  } = useDisplayedData({
    playlistAssignmentsPortals,
    total
  }, {
    loading: playlistAssignmentsPortalsLoading
  }) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    playlistAssignmentsPortals: displayedPortals,
    total: displayedTotal,
    playlistAssignmentsPortalsLoading,
    pageCount,
    query
  };
};
export const useFilteredPlaylistAssignmentsForPortal = ({
  playlistId,
  portalId,
  page = 1,
  search,
  skip
}) => {
  const [[searchUser]] = useSearchParam(FILTER_TYPES.SEARCH_USER);
  const [[assignedBy]] = useSearchParam(FILTER_TYPES.ASSIGNED_BY);
  const query = searchUser || search;
  const {
    playlistAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    total
  } = usePlaylistAssignmentsForPortal({
    playlistId,
    portalId,
    offset: (page - 1) * TABLE_SIZE,
    limit: TABLE_SIZE,
    query,
    assignedByRequestingUser: assignedBy === 'ME',
    skip
  });
  const {
    playlistAssignmentsForPortal: displayedAssignmentsForPortal,
    total: displayedTotal
  } = useDisplayedData({
    playlistAssignmentsForPortal,
    total
  }, {
    loading: playlistAssignmentsForPortalLoading
  }) || {};
  const pageCount = displayedTotal && Math.ceil(displayedTotal / TABLE_SIZE) || 1;
  return {
    playlistAssignmentsForPortal: displayedAssignmentsForPortal,
    playlistAssignmentsForPortalLoading,
    total: displayedTotal,
    pageCount,
    query
  };
};